import React, { useContext } from "react"
import { useTranslation } from "react-i18next"

import { OverlayIDContext } from "shared/context/overlay/OverlayIDContext"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

import { GlobalSearch } from "features/global-search/ui/global-search/GlobalSearch"

import { GlobalSearchOverlayModel } from "../GlobalSearchOverlay"
import "../styles/_global-search-overlay.scss"

export const GlobalSearchOverlayView = React.memo(
  ({
    options,
    isLoading,
    searchTerm,
    onSearchTermChange,
    onChange,
    onClose,
    history
  }: GlobalSearchOverlayModel) => {
    const { t } = useTranslation()
    const overlayID = useContext(OverlayIDContext)
    return (
      <OverlayWrapper
        id="global-search-overlay"
        className="global-search-overlay"
        classNamePrefix="global-search-overlay"
        mobileFullscreen
      >
        <h2 className="visually-hidden" id={`${overlayID}-title`}>
          {t("GlobalSearch.DialogTitle")}
        </h2>
        <GlobalSearch
          options={options}
          isLoading={isLoading}
          searchTerm={searchTerm}
          onSearchTermChange={onSearchTermChange}
          onChange={onChange}
          history={history}
        >
          <div className="global-search-overlay__header">
            <GlobalSearch.Input autoFocus />
            <Button
              variant={ButtonVariant.SECONDARY}
              className="btn--borderless"
              label={t("General.Close")}
              onClick={onClose}
              icon={IconName.CLOSE}
              isIconOnly
            />
          </div>
          <div className="global-search-overlay__results">
            <GlobalSearch.SearchHistory />
            <GlobalSearch.Tabs />
          </div>
          <GlobalSearch.Status />
        </GlobalSearch>
      </OverlayWrapper>
    )
  }
)
